import { render, staticRenderFns } from "./TableLabel.vue?vue&type=template&id=64377a84&"
import script from "./TableLabel.vue?vue&type=script&lang=js&"
export * from "./TableLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports